/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Referral/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Actions from './Actions/index'
import React from 'react'
import Type from './Type/index'
import Value from './Value/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Referral({
  children,
  viewPath = "/App/Account/NewPatient/Content/Form/ReferralsSection/New/Confirm/Content/Referral"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Referral.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-ZLvzN1': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--g-2-ZLvzN1': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Referral.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Type
  viewPath={`${viewPath}/Type`}
/>
</div>
<div
  data-testid="Referral.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<Value
  viewPath={`${viewPath}/Value`}
/>
</div>
<div
  data-testid="Referral.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
</div>
{children}
</React.Fragment>)
}